module.exports = __webpack_public_path__ + "static/media/ssangyong-go-drive.5ef9a41a.png";